import {Component, OnInit} from '@angular/core';
import {GlobalService} from '../../../global.service';
import {EventsService} from '../../events.service';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-cfc',
  templateUrl: './cfc.component.html',
  styleUrls: ['./cfc.component.css']
})
export class CfcComponent implements OnInit {
  language: any ;
  langChosen: string = 'en';
  selectedIndex: number = 0;

  constructor(public eventService: EventsService, public globalService: GlobalService,private titleService:Title) {
    this.titleService.setTitle('CFC-Fortnite')
    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.language = require('./lang/' + localStorage.getItem('language') + '.json');
        this.langChosen = localStorage.getItem('language');
      } else {
        this.language = require('./lang/en.json');
      }
    }
  }

  ngOnInit() {
  }

  selectedIndexChange(val: number) {
    this.selectedIndex = val;
  }

  nexttab() {
    this.selectedIndex = 1;
  }


  getDayName(index) {
    if (index > 15) {
      switch (index) {
        case 16:
          return 'Semi Final 1';
        case 17:
          return 'Semi Final 2';
        case 18:
          return 'Final';
      }
    } else {
      return this.language.Day + ' ' + index
    }
  }

  languageChange(value) {
    if (this.globalService.isBrwoser) {
      this.langChosen = value;
      this.language = require('./lang/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);
    }
  }

  getDamageRate(damage_rate) {
    if (damage_rate) {
      if (damage_rate.length > 0) {
        return damage_rate.reduce((a, b) => {
          return parseInt(a) + parseInt(b)
        }, 0)
      } else
        return 0
    }
  }
}
